export const validation_messages = {
	name: [
		{ type: 'required', message: 'Name required' },
		{ type: 'minlength', message: 'Name must be at least 1 character long' },
		{ type: 'maxlength', message: 'Name cannot be more than 25 characters long' }
	],
	first_name: [
		{ type: 'required', message: 'First Name required' },
		{ type: 'minlength', message: 'Name must be at least 1 character long' },
		{ type: 'maxlength', message: 'Name cannot be more than 25 characters long' }
	],
	last_name: [
		{ type: 'required', message: 'Last Name required' },
		{ type: 'minlength', message: 'Name must be at least 1 character long' },
		{ type: 'maxlength', message: 'Name cannot be more than 25 characters long' }
	],
	email: [
		{ type: 'required', message: 'Email is required' },
		{ type: 'pattern', message: 'Enter a valid email' },
		{ type: 'valid', message: 'Your email has already been taken' }
	],

	password: [
		{ type: 'required', message: 'Password is required' },
		{ type: 'minlength', message: 'Password must be at least 8 characters long' }
		// { type: 'pattern', message: 'Your password must contain at least one uppercase, one lowercase, and one number' }
	],

	phone: [
		{ type: 'required', message: 'A Phone Number is required' },
		{ type: 'pattern', message: 'Enter a valid phone number' },
		{ type: 'valid', message: 'Phone Number has already been taken' }
	],

	message: [
		{ type: 'required', message: 'A message is required.' },
		{ type: 'minlength', message: 'Message cannot be empty.' }
	],

	terms: [{ type: 'pattern', message: 'You must accept terms and conditions' }],

	subject: [{ type: 'required', message: 'An email subject is required.' }],

	body: [{ type: 'required', message: 'An email body is required.' }],

	title: [{ type: 'required', message: 'A title is required.' }],

	description: [{ type: 'required', message: 'An description is required.' }]
};
